import request from "@/utils/request";

export const fetchCourseList = (params) => {
  return request({ url: "/course/index", method: "get", params });
};

export const getCourseDetail = (params) => {
  return request({
    url: "/course/detail",
    method: "get",
    params,
  });
};

export const getCourseChapter = (params) => {
  return request({
    url: "/course/chapter2",
    method: "get",
    params,
  });
};

export const fetchCommentList = (params) => {
  return request({
    url: "/Comment/Index",
    method: "get",
    params,
  });
};

export const getVideoUrl = (params) => {
  return request({
    url: "/studylist/detail",
    params,
  });
};

//试看视频
export const fetchFreeVideoList = (params) => {
  return request({
    url: "/course/goodfreevideo",
    method: "get",
    params,
  });
};

//试看视频
export const addStudyRecord = (data) => {
  return request({
    url: "/studylist/update",
    method: "post",
    data,
  });
};
